import { css } from '@emotion/core'
import { measures } from 'styles/variables'
import * as MQ from 'styles/media-queries'

const { unit } = measures

export const signupContainer = css`
  display: flex;
  justify-content: center;
  width: 100%;
`

export const textContainer = css`
  display: flex;
  flex-direction: column;
  gap: ${2 * unit}px;
  text-align: justify;

  > * {
    line-height: ${3 * unit}px;
  }
`

export const privacySection = css`
  display: flex;
  flex-direction: column;
  align-items: center;

  padding: ${2 * unit}px;
  width: 100%;

  ${MQ.NOT_PHONES} {
    max-width: 60%;
  }
`

export const linkCustom = css`
  text-decoration: none;
  color: #6d61ff;
`
